
import { i18nText } from '@/locales';


import {Button, Col, FormModel, Modal, Row, Table, Tabs, Tree} from "ant-design-vue";
import {Component, Prop, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";

import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import {showNotification, showNotificationSimple} from "@/UI/lib/messages";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import TabCustom from "@/UI/components/common/TabCustom.vue";
import {ITableColumn} from "@/entity/table/table.types";
import {RouterNameEnum} from "@/router/router.types";
import {TablesStore} from "@/store/modules/Tables";

import {ServiceCategoryNomenclatureMix} from "@/UI/mixins/Service/ServiceCategoryNomenclatureMix";
import {ServiceCreateRequestType} from "@/form/serviceCreate/serviceCreate.types";

import {FormRules, ServiceCategoryNomenclatureForm} from "@/form/serviceCategory/serviceCategoryNomenclature";
import {ServicesCategoryNomenclatureStore} from "@/store/modules/ServicesCategoryNomenclature";
import {ServiceNomenclatureStore} from "@/store/modules/ServicesNomenclature";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";
import {FiltersData} from '@/entity/filters/extFilter';
import {getStudioId} from "@/UI/lib/state";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"

@Component({
  components: {
    TabCustom,
    PageTitle,
    BaseDataForm,
    "a-tab": Tabs,
    "a-tab-pane": Tabs.TabPane,
    "a-table": Table,
    "a-col": Col,
    "a-row": Row,
    "a-button": Button,
    "a-modal": Modal,
    "a-tree": Tree,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    SortComponent
  },
})
export default class ServiceIndex extends mixins(
    ServiceCategoryNomenclatureMix,
    ProxyGetData
  ) {
  @Prop() readonly mode!: number;

  filtersData = new FiltersData();
  showCategoryModal = false;
  categoryEditMode = 0;
  serviceForm = new ServiceCategoryNomenclatureForm();
  rules = FormRules;
  isPartner = false;
  requestProceed = false;

  startRequest(): void {
    this.requestProceed = true;
  }

  stopRequest(): void {
    this.requestProceed = false;
  }

  expandRowByClick(expanded: boolean, record: any): void {
    //console.log("999999");
  }

  linkToService(record: any): any {
    return {
      name: RouterNameEnum.ServiceDetail,
      params: {id: record["id"]},
    };
  }

  async removeCategory(id: number): Promise<void> {
    try {
      this.startRequest();
      const response = await ServicesCategoryNomenclatureStore.delete({id: id});
      await this.getData();
      this.$notification.open({
        message: response["response"],
        description: '',
        duration: 3,
      });
      this.showCategoryModal = false;

    } catch (e) {
      console.error(e);
    } finally {
      this.stopRequest();
    }
  }

  cancelRemoveCategory(): void {
    this.showCategoryModal = false;
  }

  addService(record: any): void {
    this.$router.push({
      name: this.$routeRules.ServicesCreation,
      params: {category_id: record.id},
    });
  }

  addCategory(): void {
    this.categoryEditMode = 0;
    this.showCategoryModal = true;
  }

  async editCategory(record: any): Promise<void> {
    this.categoryEditMode = 1;

    this.serviceForm["id"] = record["id"];
    this.serviceForm["name"] = record["name"];
    this.serviceForm["online_appointment_name"] = record["online_appointment_name"];
    this.showCategoryModal = true;
  }

  onCancelCategory(): void {
    this.showCategoryModal = false;
  }

  onSubmitCategory(): void {
    (this.$refs["categoryForm"] as FormModel).validate(async (valid) => {
      if (valid) {

        try {
          this.startRequest();
          if (this.categoryEditMode === 0) {

            const response = await ServicesCategoryNomenclatureStore.create(this.serviceForm);

            if (response && response.status) {
              this.$notification.open({
                message: i18nText("Категория создана"),
                description: response["response"],
                duration: 3,
              });
            } else {
              this.$notification.error({
                message: i18nText("Произошла ошибка"),
                description: response["response"],
                duration: 3,
              })
            }
          } else {
            const response = await ServicesCategoryNomenclatureStore.update(this.serviceForm);
            if (response && response.status) {
              this.$notification.open({
                message: i18nText("Обновление категории"),
                description: response["response"],
                duration: 3,
              });
            } else {
              this.$notification.error({
                message: i18nText("Произошла ошибка"),
                description: response["response"],
                duration: 3,
              })
            }
          }
          await this.getData();
          this.showCategoryModal = false;
        } catch (e) {
          console.log("Error client update form");
        } finally {
          this.stopRequest();
        }
      }
    });
  }

  // async getData(): Promise<void> {
  //   this.proxyFilter = {salon_id: 0};
  //   await this.createProxy();
  // }

  editService(record: any): void {
    console.log('rec', record.id)
    this.$router.push({
      name: this.$routeRules.ServiceUpdate,
      params: {id: record.id},
    });
    console.log('asdf')
    /* const newData = [...(this.$refs["serviceTable"] as Table).dataSource];
    const target = newData.filter((item) => record === item.id)[0];
    if (target) {
      target.editable = !target.editable;
      (this.$refs["serviceTable"] as Table).dataSource = newData;
    } */
  }

  async changeRecord(record: ServiceCreateRequestType): Promise<void> {
    try {
      this.startRequest();
      ServiceNomenclatureStore.update(record).then((response) => {
        showNotification(response.status ? i18nText("Запись обновлена") : i18nText("Произошла ошибка"), response);
      });
    } catch (e) {
      console.log(i18nText("Ошибка обновления"));
    } finally {
      this.stopRequest();
    }
  }

  get servicesCategoryColumns(): ITableColumn[] {
    return TablesStore.servicesCategoryColumns;
  }

  get serviceExtColumns(): ITableColumn[] {
    return TablesStore.servicesExtColumns;
  }

  customCategoryServiceRow = (record: any) => {
    return {
      on: {
        click: (event: any) => {
          console.log('');
        },
      },
    };
  };

  async tabChanged(key: string): Promise<void> {
    await this.$router.push({name: key, params: {Studio: this.$store.state["salon_id"]}});
    //await this.getData();
  }

  defaultActiveTab(): any {
    return "Services";
  }

  servicesTabs = [
    {
      id: RouterNameEnum.Services,
      name: i18nText("Услуги"),
    },
    {
      id: RouterNameEnum.PartnerServices,
      name: i18nText("Услуги партнеров"),
    },
  ];


  async created(): Promise<void> {
    console.log('check12345')

    // this.isPartner = Vue.auth.check("owner");
    this.formReady = false;
    // if (!this.isPartner) {
    // }
      try {
        this.proxyFilter = {
          salon_id: getStudioId(this)
        }
        appPaginationStore.setCurrent(1)
        await this.sortedData('desc', {dataIndex: 'created_at'})
        await this.fetchModules([
          {s: 'category', p: {limit: -1}}
        ])
      } catch (e) {
        console.error();
      } finally {
        this.formReady = true;
      }
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, {dataIndex: sort.dataIndex})
  }
}
